import React, { PureComponent } from "react";

import Slot from "../../_molecules/Slot";
import ContentTitle from "../../_atoms/ContentTitle";

import { PromoSlotsWrapper, FeaturedSlotsContainer } from "./styled-components";

export default class FeaturedSlots extends PureComponent {
  static defaultProps = {
    qaLabel: "featured-slots"
  };

  render() {
    const { content, qaLabel } = this.props;

    return (
      <PromoSlotsWrapper data-qa-label={qaLabel}>
        <ContentTitle
          content={{
            header: content.header,
            className: "promoTopSlotsTitle"
          }}
          qaLabel={`${qaLabel}HeaderTitle`}
        />
        <FeaturedSlotsContainer data-qa-label={`${qaLabel}Container`}>
          {content.slots.map((slot) => (
            <Slot
              key={slot._uid}
              isTopPromo
              content={slot}
              qaLabel={`${qaLabel}Slot`}
            />
          ))}
        </FeaturedSlotsContainer>
      </PromoSlotsWrapper>
    );
  }
}
